import React from "react";
import Navbar from "../../common/navbar/mainnavbar";
import Footer from "../../common/footer/index";
import Logo from "../../assets/img/logo/logorumneo.svg";

const DownloadApp = () => {
  return (
    <>
      <Navbar />

      {/* Scoped styles & animations */}
      <style>{`
        .dl-hero {
          position: relative;
          overflow: hidden;
          min-height: 88vh;
          display: flex;
          align-items: center;
          background:
            radial-gradient(1200px 600px at 10% -10%, rgba(40,167,69,.18), transparent 60%),
            radial-gradient(900px 500px at 110% 110%, rgba(25,135,84,.20), transparent 55%),
            linear-gradient(135deg, #f6fbf8 0%, #eef7f1 100%);
        }
        .dl-blob {
          position: absolute;
          border-radius: 50%;
          filter: blur(40px);
          opacity: .35;
          z-index: 0;
          animation: dlFloat 9s ease-in-out infinite;
        }
        .dl-blob.one { width: 280px; height: 280px; background: #34d399; top: -60px; left: -40px; }
        .dl-blob.two { width: 220px; height: 220px; background: #10b981; bottom: -50px; right: 6%; animation-delay: 1.5s; }
        .dl-blob.three { width: 160px; height: 160px; background: #6ee7b7; top: 40%; right: 18%; animation-delay: 3s; }

        @keyframes dlFloat {
          0%,100% { transform: translateY(0) translateX(0); }
          50% { transform: translateY(-22px) translateX(14px); }
        }

        .dl-card {
          position: relative;
          z-index: 2;
          background: rgba(255,255,255,.72);
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
          border: 1px solid rgba(255,255,255,.6);
          border-radius: 28px;
          box-shadow: 0 24px 60px -20px rgba(16,46,32,.35);
          padding: 44px 38px;
        }

        .dl-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #fffbeb;
          color: #92400e;
          border: 1px solid #fcd34d;
          border-radius: 999px;
          padding: 7px 18px;
          font-size: 12.5px;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
        }
        .dl-dot {
          width: 8px; height: 8px; border-radius: 50%;
          background: #f59e0b;
          box-shadow: 0 0 0 0 rgba(245,158,11,.6);
          animation: dlPulse 1.6s infinite;
        }
        @keyframes dlPulse {
          0% { box-shadow: 0 0 0 0 rgba(245,158,11,.55); }
          70% { box-shadow: 0 0 0 12px rgba(245,158,11,0); }
          100% { box-shadow: 0 0 0 0 rgba(245,158,11,0); }
        }

        .dl-title {
          font-size: clamp(2rem, 5vw, 3.1rem);
          font-weight: 900;
          color: #102e20;
          line-height: 1.12;
          margin: 22px 0 14px;
          letter-spacing: -.5px;
        }
        .dl-title .grad {
          background: linear-gradient(90deg, #16a34a, #059669);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .dl-sub {
          font-size: 1.06rem;
          color: #4b6a5a;
          font-weight: 500;
          line-height: 1.65;
          margin-bottom: 22px;
        }

        .dl-launch {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          font-size: 1rem;
          font-weight: 700;
          color: #102e20;
          background: #ffffff;
          border: 1px solid #d1fae5;
          border-radius: 14px;
          padding: 12px 18px;
          margin-bottom: 30px;
          box-shadow: 0 8px 20px -12px rgba(16,46,32,.3);
        }
        .dl-launch .chip {
          background: linear-gradient(90deg, #16a34a, #059669);
          color: #fff;
          border-radius: 8px;
          padding: 3px 12px;
          font-weight: 800;
          white-space: nowrap;
        }

        .dl-store {
          display: inline-flex;
          align-items: center;
          gap: 14px;
          background: #0b0f0d;
          color: #fff;
          border-radius: 16px;
          padding: 13px 26px;
          text-decoration: none;
          box-shadow: 0 16px 34px -14px rgba(0,0,0,.55);
          transition: transform .25s ease, box-shadow .25s ease;
          cursor: not-allowed;
        }
        .dl-store:hover {
          transform: translateY(-3px);
          box-shadow: 0 22px 42px -14px rgba(0,0,0,.6);
          color: #fff;
        }
        .dl-store .gp-icon { width: 30px; height: 30px; }
        .dl-store .gp-text small { display:block; font-size: 11px; opacity:.75; letter-spacing:.5px; }
        .dl-store .gp-text strong { display:block; font-size: 19px; line-height:1.1; font-weight: 800; }

        .dl-soon {
          font-size: 12.5px;
          color: #6b7c73;
          margin-top: 14px;
        }

        /* Phone mockup */
        .dl-phone-wrap {
          position: relative;
          z-index: 2;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .dl-phone {
          position: relative;
          width: 260px;
          height: 520px;
          background: linear-gradient(160deg, #0f5132, #16a34a 55%, #34d399);
          border-radius: 42px;
          padding: 14px;
          box-shadow: 0 40px 80px -30px rgba(16,46,32,.7), inset 0 0 0 2px rgba(255,255,255,.18);
          animation: dlPhoneFloat 6s ease-in-out infinite;
        }
        @keyframes dlPhoneFloat {
          0%,100% { transform: translateY(0) rotate(-2deg); }
          50% { transform: translateY(-18px) rotate(-2deg); }
        }
        .dl-screen {
          width: 100%; height: 100%;
          background: #f8fdfa;
          border-radius: 30px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 24px;
        }
        .dl-screen img { width: 110px; margin-bottom: 18px; }
        .dl-screen h5 { color:#0f5132; font-weight:800; margin:0; }
        .dl-screen p { color:#5b7a6b; font-size:13px; margin-top:6px; margin-bottom: 18px; }
        .dl-notch {
          position:absolute; top:14px; left:50%; transform:translateX(-50%);
          width: 110px; height: 22px; background:#0b0f0d; border-radius: 0 0 16px 16px; z-index:3;
        }
        .dl-skeleton { width: 80%; height: 10px; border-radius: 6px; background: #e3f3ea; margin: 6px 0; }
        .dl-skeleton.short { width: 55%; }

        @media (max-width: 991px) {
          .dl-card { text-align: center; }
          .dl-card .dl-launch { text-align: left; }
          .dl-phone { margin-top: 8px; }
        }
      `}</style>

      <section className="dl-hero">
        <span className="dl-blob one" />
        <span className="dl-blob two" />
        <span className="dl-blob three" />

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="row align-items-center g-5 py-5">
            {/* Left: content */}
            <div className="col-lg-7">
              <div className="dl-card">
                <span className="dl-badge">
                  <span className="dl-dot" /> Under Development
                </span>

                <h1 className="dl-title">
                  Download the <span className="grad">Rumeno App</span>
                </h1>

                <p className="dl-sub">
                  Your complete livestock management companion — track animal
                  health, nutrition, breeding records, expenses, and much more,
                  all from your phone. Smart farming, made simple.
                </p>

                <div className="dl-launch">
                  <span role="img" aria-label="rocket"></span>
                  Launching soon — before
                  <span className="chip">August - 2026</span>
                </div>

                <div>
                  <a
                    className="dl-store"
                    href="https://play.google.com/store"
                    onClick={(e) => e.preventDefault()}
                    title="Coming soon on Google Play"
                  >
                    <svg className="gp-icon" viewBox="0 0 512 512" aria-hidden="true">
                      <path fill="#00d2ff" d="M48 59v394c0 8 4 15 11 19l228-216L59 40c-7 4-11 11-11 19z" />
                      <path fill="#00f076" d="M59 40l228 216 62-59L94 17C82 10 69 12 59 40z" />
                      <path fill="#ffce00" d="M349 197l-62 59 62 59 89-50c17-10 17-18 0-28z" />
                      <path fill="#ff3a44" d="M287 256L59 472c10 28 23 30 35 23l255-148z" />
                    </svg>
                    <span className="gp-text">
                      <small>GET IT ON</small>
                      <strong>Google Play</strong>
                    </span>
                  </a>
                  <p className="dl-soon">⏳ Available soon on the Google Play Store</p>
                </div>
              </div>
            </div>

            {/* Right: phone mockup */}
            <div className="col-lg-5">
              <div className="dl-phone-wrap">
                <div className="dl-phone">
                  <span className="dl-notch" />
                  <div className="dl-screen">
                    <img src={Logo} alt="Rumeno" />
                    <h5>Rumeno</h5>
                    <p>Smart Livestock Management</p>
                    <div className="dl-skeleton" />
                    <div className="dl-skeleton short" />
                    <div className="dl-skeleton" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default DownloadApp;
